import React, { ReactNode, useState } from "react";
import { getCibilReport } from "../../../apis/customers";
import Table from "../../../core/common/dataTable/index";

const Cibil = () => {
  const [aadharNumber, setAadharNumber] = useState<string>("");
  const [cibilData, setCibilData] = useState<CibilData[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAadharNumber(e.target.value);
  };

  type CibilResponse = {
    branch_name: string;
    branch_code: string;
    branch_address: string;
    Status: string;
    id: any;
  };

  type CibilData = {
    emi_details: any;
    status: ReactNode;
    requestedAmount: ReactNode;
    numberOfEmis: ReactNode;
    loan_id: ReactNode;
    loans: any;
    financer: any;
    full_name: string;
    key: number;
    EmpId: string;
    Name: string;
    Status: string;
    id: any;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!aadharNumber || aadharNumber.length !== 12) {
      alert("Please enter a valid 12-digit Aadhar number.");
      return;
    }
    try {
      const res = await getCibilReport({ aadharNumber });
      setCibilData(res.data?.map((item, i) => ({ ...item, key: `${i + 1}` })));
    } catch (err: any) {
      console.error("Error fetching CIBIL report:", err);
      alert(err.response.data.message);
    }
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
    },
    {
      title: "Financer Name",
      dataIndex: "Name",
      render: (_: any, record: CibilData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record?.financer?.full_name}</p>
          </div>
        </div>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Financer Mobile No",
      dataIndex: "Status",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.financer?.mobile_number}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Financer Company",
      dataIndex: "Status",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.financer?.company_name}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
  ];

  const columnsLoans = [
    {
      title: "Sr No",
      dataIndex: "key",
    },
    {
      title: "Loan Id",
      dataIndex: "Name",
      render: (_: any, record: CibilData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record?.loan_id}</p>
          </div>
        </div>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Name.localeCompare(b.Name),
    },
    {
      title: "No. of EMIs",
      dataIndex: "Status",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.numberOfEmis}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Requested Amount",
      dataIndex: "Status",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.requestedAmount}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.status}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Amount Pending",
      dataIndex: "emi_details",
      render: (_: any, record: CibilData) => (
        <span>
          <p className="text-dark mb-0">{record?.emi_details?.[0]?.emis?.filter(item => item.status == "Pending").reduce((a, b) => {
            return a + b.amount;
          }, 0)}</p>
        </span>
      ),
      sorter: (a: CibilData, b: CibilData) => a.Status.localeCompare(b.Status),
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body p-0">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <form onSubmit={handleSubmit}>
                  <div className="contact-grids-tab">
                    <ul className="nav nav-underline" id="myTab2" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="info-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info2"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          CIBIL Report
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent2">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Enter Your Aadhar Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="aadharNumber"
                            value={aadharNumber}
                            onChange={handleChange}
                            className="form-control"
                            maxLength={12}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-outline-light border me-2" onClick={() => setAadharNumber("")}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Get Report
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div
              style={{
                width: "85%",
                marginTop: "1%",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "darkcyan",
                borderRadius: 10,
              }}
            >
              <h3 style={{ color: "#fff", paddingLeft: "1%", paddingBlock: "1%" }}>Credit Report of {cibilData[0]?.full_name}</h3>
            </div>
            <div>
              <span>Customer Aadhar Number</span>
            </div>
          </div>
          <Table dataSource={cibilData} columns={columns} Selection={false} />
          <Table
            dataSource={cibilData.flatMap((item) => item.loans).map((item, i) => ({ ...item, key: `${i + 1}` }))}
            columns={columnsLoans}
            Selection={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Cibil;
